import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './globalcss.css';

import routes from './routes';
import registerServiceWorker from './registerServiceWorker';
import App from './App';
// import Aboutus from './Component/About/About';
// import Contact from './Component/Contact/Contact';
// import Homecomp from './Component/Home/Home';
import Login from './Component/Login/Login';
import Register from './Component/Register/Register';
// import Otp from './Component/Otp/Otp';
// import Forgetpwd from './Component/Forgetpwd/Forgetpwd';
// import Changepwd from './Component/Changepwd/Changepwd';
// import Successmsg from './Component/Successmsg/Successmsg';
// import Create from './Component/Create/Create';
// import Browse from './Component/Browse/Browse';
// import Profile from './Component/Profile/Profile';

import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import {createStore,applyMiddleware} from 'redux';
import {Provider} from "react-redux";
import thunk from "redux-thunk";
import rootReducer from "../src/redux/rootReducer";
import Useraccount from './Component/Useraccount/Useraccount';
// import Mytaps from './Component/Mytaps/Mytaps';
import asyncComponent from "./Component/AsyncComponent";


import { config } from "./push/firebaseConfig"
import initializePush from './push/initialize';
import firebase from "firebase";


firebase.initializeApp(config);
registerServiceWorker();

const Homecomp = asyncComponent(() => import("./Component/Home/Home"));
const Aboutus = asyncComponent(() => import("./Component/About/About"));
const Browse = asyncComponent(() => import("./Component/Browse/Browse"));
const Mytaps = asyncComponent(() => import("./Component/Mytaps/Mytaps"));
const Profile = asyncComponent(() => import("./Component/Profile/Profile"));
const Forgetpwd = asyncComponent(() => import("./Component/Forgetpwd/Forgetpwd"));
const Changepwd = asyncComponent(() => import("./Component/Changepwd/Changepwd"));
const Otp = asyncComponent(() => import("./Component/Otp/Otp"));
const Successmsg = asyncComponent(() => import("./Component/Successmsg/Successmsg"));
const Contact = asyncComponent(() => import("./Component/Contact/Contact"));
const Create = asyncComponent(() => import("./Component/Create/Create"));
const Action = asyncComponent(() => import("./Component/ActionPage/ActionPage"));
const payment = asyncComponent(() => import("./Component/payment/payment"));
const Fullcalendar = asyncComponent(() => import("./Component/Fullcalendar/Fullcalendar"));

// firebase.initializeApp(config);// Initialize the firebase app
registerServiceWorker(); // Register the service worker

let store =createStore(rootReducer,applyMiddleware(thunk))

ReactDOM.render(<Provider store={store}><BrowserRouter>
    <Switch>
        
        <Route exact path='/about' component={Aboutus} />
        <Route exact path='/contact' component={Contact} />
        <Route exact path='/home' component={Homecomp} />
        {/* <Route exact path='/login' component={Login} /> */}
        {/* <Route exact path='/register' component={Register} /> */}
        <Route exact path='/otp' component={Otp} />
        <Route exact path='/forgetpwd' component={Forgetpwd} />
        <Route exact path='/changepwd' component={Changepwd} />
        <Route exact path='/successmsg' component={Successmsg} />
        <Route exact path='/create' component={Create} />
        <Route exact path='/browse' component={Browse} />
        <Route exact path='/action' component={Action} />
        <Route path='/profile' component={Profile} />
        <Route path='/payment' component={payment} />
        <Route path='/fullcalendar' component={Fullcalendar} />
        <Route path='/mytaps' component={Mytaps} />
        <Route exact path='/useraccount' component={Useraccount} />
        {/* <Route exact path='/library' component={Library} /> */}
        <Route exact path='/' component={Homecomp} />
    </Switch>
</BrowserRouter></Provider> , document.getElementById('root'));

initializePush(); //Initializing the push notification

const messaging = firebase.messaging();
messaging.onMessage(payload=>{
    console.log("got message",payload);
    
    // return self.registration.showNotification(title, options);


})
{/* <BrowserRouter>
    <Switch>
        <Route exact path='/' component={Homecomp} />
        <Route exact path='/about' component={Aboutus} />
        <Route path='/contact' component={Contact} />
        <Route path='/home' component={Homecomp} />
    </Switch>
</BrowserRouter> */}


// WEBPACK FOOTER //
// ./src/index.js